import { ButtonStyleModel } from '../../models/layout/components/button/ButtonModel'

export function formatButtonStyle(data) {
  const b = new ButtonStyleModel()
  b.fromData(data)

  return b
}
